const alen = (array) => (Array.isArray(array) ? array.length : 0);

export default alen;
